import { ReactNode } from "react";
import { Typography } from "@foodpilot/foods";
import { Box, Stack, useTheme } from "@mui/material";
import { LineScoreValue } from "../Layout/LineScoreValue";

export const IMPACT_EXPAND_ICON_SLOT_WIDTH = 18;
export const IMPACT_VALUE_NUMBER_MIN_WIDTH = "4.5rem";

type ImpactScoreColumnProps = {
    value: string | null;
    valueColor?: string;
    valueSize?: "micro" | "small";
    trailingSlot?: ReactNode;
    /** Hides the expand-icon placeholder (transport route rows). */
    hideTrailingSlot?: boolean;
    unit?: string;
};

export const ImpactScoreColumn = (props: ImpactScoreColumnProps) => {
    const { value, valueColor, valueSize = "micro", trailingSlot, hideTrailingSlot = false, unit = "Pts" } = props;
    const theme = useTheme();

    const valueNumberSx =
        valueSize === "small" ?
            { fontWeight: 700, fontSize: "16px", lineHeight: 1.5 }
        :   { fontWeight: 700, fontSize: "14px", lineHeight: 1.5 };

    return (
        <Stack direction="row" alignItems="center" gap={0.5} sx={{ flexShrink: 0 }}>
            {value === null ?
                <LineScoreValue value={null} unit={unit} size={valueSize} />
            :   <Stack direction="row" alignItems="end" gap={0.5} sx={{ color: valueColor ?? theme.custom.grey[2000] }}>
                    <Typography
                        sx={{
                            ...valueNumberSx,
                            fontFamily: "Montserrat",
                            fontVariantNumeric: "tabular-nums",
                            minWidth: IMPACT_VALUE_NUMBER_MIN_WIDTH,
                            textAlign: "right",
                        }}
                    >
                        {value}
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: "Montserrat",
                            fontWeight: 400,
                            fontSize: valueSize === "small" ? "14px" : "12px",
                            lineHeight: 1.6,
                        }}
                    >
                        {unit}
                    </Typography>
                </Stack>
            }
            {!hideTrailingSlot && (
                <Box
                    sx={{
                        width: IMPACT_EXPAND_ICON_SLOT_WIDTH,
                        height: IMPACT_EXPAND_ICON_SLOT_WIDTH,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                    }}
                >
                    {trailingSlot}
                </Box>
            )}
        </Stack>
    );
};
